import React, { useContext, useState, useEffect } from "react";
import CelebSidebar from "../../sidebar/index";
import Navbar from "../../landingpage/sections/Navbar/index";
import Footer from "../../home/footer";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { AuthContext } from "../../../context/AuthContext";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as eventService from "../../../services/eventService";
import AttendeeList from "./AttendeeList";
import TicketInventory from "./TicketInventory";
import PromoCodes from "./PromoCodes";
import EventSchedule from "./EventSchedule";
import EventListings from "./EventListings";

const CelebEvents = (props) => {
  const { user } = useContext(AuthContext);
  const dataTheme = useSelector((state) => state.themeSetting.dataTheme);
  const isDark = dataTheme === "dark-mode";

  const [activeTab, setActiveTab] = useState("listings");
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentEventId, setCurrentEventId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [attendees, setAttendees] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [promoCodes, setPromoCodes] = useState([]);
  const [promoStats, setPromoStats] = useState({
    activeDiscounts: 0,
    totalRedeemed: 0,
    revenueImpact: 0,
    topCode: "N/A",
  });

  const [stats, setStats] = useState({
    totalEvents: 0,
    upcomingEvents: 0,
    completedEvents: 0,
    totalRevenue: 0,
  });

  const [attendeeStats, setAttendeeStats] = useState({
    totalAttendees: 0,
    checkIns: 0,
    ticketRevenue: 0,
  });

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      background: isDark ? "#0a0a0a" : "#fafafa",
      borderRadius: "10px",
      padding: "2px 5px",
      minHeight: "38px",
      fontSize: "0.9rem",
      border: state.isFocused
        ? "1px solid #ff9800"
        : isDark
          ? "1px solid #262626"
          : "1px solid #eee",
      boxShadow: state.isFocused
        ? "0 0 0 0.25rem rgba(255, 152, 0, 0.1)"
        : "none",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: "#ff9800",
      },
    }),
    menu: (base) => ({
      ...base,
      background: isDark ? "#0a0a0a" : "#fff",
      borderRadius: "12px",
      boxShadow: isDark
        ? "0 4px 20px rgba(0,0,0,0.5)"
        : "0 4px 15px rgba(0,0,0,0.1)",
      border: isDark ? "1px solid #262626" : "1px solid #eee",
      padding: "5px",
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "0.85rem",
      backgroundColor: state.isSelected
        ? "#ff9800"
        : state.isFocused
          ? isDark
            ? "rgba(255, 255, 255, 0.05)"
            : "rgba(255, 152, 0, 0.05)"
          : "transparent",
      color: state.isSelected ? "#fff" : isDark ? "#fafafa" : "#444",
      borderRadius: "8px",
      margin: "2px 0",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#ff9800",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: isDark ? "#fafafa" : "#444",
    }),
    placeholder: (base) => ({
      ...base,
      color: isDark ? "#666" : "#aaa",
    }),
  };

  const categoryOptions = [
    { value: "Technology", label: "Technology" },
    { value: "Music", label: "Music & Arts" },
    { value: "Education", label: "Education" },
    { value: "Business", label: "Business" },
    { value: "Entertainment", label: "Entertainment" },
    { value: "Sports", label: "Sports" },
  ];

  const visibilityOptions = [
    { value: "public", label: "Public (Visible to everyone)" },
    { value: "private", label: "Private (Only via link)" },
  ];

  const locationOptions = [
    { value: "Physical", label: "Physical" },
    { value: "Virtual", label: "Virtual" },
    { value: "Hybrid", label: "Hybrid" },
  ];

  const platformOptions = [
    { value: "Google Meet", label: "Google Meet" },
    { value: "Zoom", label: "Zoom" },
    { value: "Microsoft Teams", label: "Microsoft Teams" },
    { value: "Skype", label: "Skype" },
    { value: "Discord", label: "Discord" },
    { value: "Other", label: "Other Platform" },
  ];

  const discountTypeOptions = [
    { value: "percentage", label: "Percentage (%)" },
    { value: "fixed", label: "Fixed Amount ($)" },
  ];

  const [formData, setFormData] = useState({
    title: "",
    category: null,
    visibility: visibilityOptions[0],
    description: "",
    locationType: locationOptions[0],
    venue: "",
    virtualPlatform: null,
    meetingLink: "",
    startDate: "",
    endDate: "",
    salesEndDate: "",
    tickets: [{ name: "Standard", quantity: 100, price: 10 }],
  });

  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const [promoFormData, setPromoFormData] = useState({
    code: "",
    event: null,
    description: "",
    type: discountTypeOptions[0],
    value: "",
    minTickets: 1,
    maxUses: "",
    expiryDate: "",
  });

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    if (activeTab === "promo") {
      fetchDiscounts();
    }
    if (activeTab === "attendees") {
      fetchAttendees();
    }
    if (activeTab === "tickets") {
      fetchTickets();
    }
  }, [activeTab]);

  const fetchTickets = async () => {
    try {
      setLoading(true);
      const response = await eventService.getMyTickets();
      if (response && response.success) {
        setTickets(Array.isArray(response.data) ? response.data : []);
      }
    } catch (error) {
      console.error("Error fetching tickets:", error);
      if (error.message !== "No tickets found") {
        toast.error("Failed to load tickets");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchAttendees = async () => {
    try {
      setLoading(true);
      const response = await eventService.getMyAttendees();
      if (response && response.success) {
        const attendeeList = Array.isArray(response.data) ? response.data : [];
        setAttendees(attendeeList);

        let checkIns = 0;
        attendeeList.forEach((att) => {
          if (att.status?.toLowerCase() === "checked-in") checkIns++;
        });

        setAttendeeStats({
          totalAttendees: attendeeList.length,
          checkIns: checkIns,
          ticketRevenue: attendeeStats.ticketRevenue,
        });
      }
    } catch (error) {
      console.error("Error fetching attendees:", error);
      if (error.message !== "No attendees found") {
        toast.error("Failed to load attendees");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchDiscounts = async () => {
    try {
      setLoading(true);
      const response = await eventService.getMyDiscounts();
      if (response && response.success) {
        const discountList = Array.isArray(response.data) ? response.data : [];
        setPromoCodes(discountList);

        let active = 0;
        let redeemed = 0;
        let impact = 0;
        let maxRedeemed = 0;
        let topCode = "N/A";

        discountList.forEach((d) => {
          if (d.status === "active") active++;
          redeemed += d.currentUses || 0;
          impact += (d.currentUses || 0) * (d.amount || 0);

          if ((d.currentUses || 0) > maxRedeemed) {
            maxRedeemed = d.currentUses;
            topCode = d.code;
          }
        });

        setPromoStats({
          activeDiscounts: active,
          totalRedeemed: redeemed,
          revenueImpact: impact,
          topCode: topCode,
        });
      }
    } catch (error) {
      console.error("Error fetching discounts:", error);
      if (error.message !== "No discounts found") {
        toast.error("Failed to load promo codes");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await eventService.getMyEvents();
      let eventsList = [];

      if (response && response.success) {
        eventsList = Array.isArray(response.data) ? response.data : [];
      } else if (response && response.message !== "No events found") {
        toast.error(response.message || "Failed to load events");
      }

      setEvents(eventsList);

      const now = new Date();
      let upcoming = 0;
      let completed = 0;
      let revenue = 0;

      eventsList.forEach((event) => {
        const startDate = new Date(event.startDate);
        const endDate = new Date(event.endDate);

        if (startDate > now) upcoming++;
        if (endDate < now) completed++;

        if (event.ticketTiers) {
          event.ticketTiers.forEach((tier) => {
            revenue += (tier.price || 0) * (tier.soldCount || 0);
          });
        }
      });

      setStats({
        totalEvents: eventsList.length,
        upcomingEvents: upcoming,
        completedEvents: completed,
        totalRevenue: revenue,
      });
    } catch (error) {
      console.error("Error fetching events:", error);
      if (error.message !== "No events found") {
        toast.error("Failed to load events");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 1 * 1024 * 1024) {
        toast.error("Image size should be less than 1MB");
        return;
      }
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Event title is required";
    if (!formData.category) newErrors.category = "Please select a category";
    if (!formData.description) newErrors.description = "Event description is required";
    if (!formData.startDate) newErrors.startDate = "Start date is required";
    if (!formData.endDate) newErrors.endDate = "End date is required";
    if (formData.startDate && formData.endDate && new Date(formData.startDate) >= new Date(formData.endDate)) {
      newErrors.endDate = "End date must be after start date";
    }
    if ((formData.locationType?.value === "Physical" || formData.locationType?.value === "Hybrid") && !formData.venue) {
      newErrors.venue = "Physical venue address is required";
    }
    if ((formData.locationType?.value === "Virtual" || formData.locationType?.value === "Hybrid") && !formData.meetingLink) {
      newErrors.meetingLink = "Meeting link is required";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateEvent = async (e) => {
    e.preventDefault();
    if (loading) return;
    
    if (!validateForm()) {
      toast.error("Please fix the errors in the form");
      return;
    }

    try {
      setLoading(true);
      let imageUrl = previewImage; // Keep existing if editing

      if (imageFile) {
        const uploadResponse = await eventService.uploadMedia(imageFile);
        if (uploadResponse && uploadResponse.success) {
          imageUrl =
            uploadResponse.data?.url ||
            uploadResponse.url ||
            (typeof uploadResponse.data === "string"
              ? uploadResponse.data
              : "");
        } else {
          throw new Error(uploadResponse.message || "Image upload failed");
        }
      }

      const totalCapacity = formData.tickets.reduce(
        (sum, t) => sum + Number(t.quantity || 0),
        0,
      );

      const payload = {
        title: formData.title,
        description: formData.description,
        location: formData.venue,
        locationType: formData.locationType?.value || formData.locationType,
        virtualPlatform:
          formData.virtualPlatform?.value || formData.virtualPlatform,
        meetingLink: formData.meetingLink,
        startDate: formData.startDate,
        endDate: formData.endDate,
        visibility: formData.visibility?.value || formData.visibility,
        type: "paid",
        source: "howzit",
        category: formData.category?.value || formData.category,
        image: imageUrl,
        status: "published",
        ticketTiers: formData.tickets.map((t) => ({
          name: t.name,
          price: Number(t.price),
          capacity: Number(t.quantity),
        })),
        totalCapacity: totalCapacity,
      };

      if (isEditing && currentEventId) {
        await eventService.updateEvent(currentEventId, payload);
        toast.success("Event updated successfully!");
      } else {
        await eventService.createEvent(payload);
        toast.success("Event created successfully!");
      }

      handleCancelEdit();
      fetchEvents();
    } catch (error) {
      console.error("Error creating event:", error);
      toast.error(error.message || "Failed to create event");
    } finally {
      setLoading(false);
    }
  };

  const handleCreatePromo = async (e) => {
    e.preventDefault();
    if (!promoFormData.code || !promoFormData.event) {
      toast.warn("Please fill in required fields");
      return;
    }

    try {
      setLoading(true);
      const eventObj = events.find(
        (e) => (e._id || e.id) === promoFormData.event.value,
      );

      const payload = {
        code: promoFormData.code,
        eventId: promoFormData.event.value,
        type: promoFormData.type.value,
        amount: Number(promoFormData.value),
        description: promoFormData.description,
        minTickets: Number(promoFormData.minTickets) || 1,
        maxUses: Number(promoFormData.maxUses) || 0,
        expiresAt: promoFormData.expiryDate
          ? new Date(promoFormData.expiryDate).toISOString()
          : null,
        applicableTiers: eventObj?.ticketTiers?.map((t) => t.name) || [],
      };

      await eventService.createDiscount(payload);
      toast.success("Promo code created successfully!");
      setShowPromoModal(false);
      fetchDiscounts();
    } catch (error) {
      console.error("Error creating promo:", error);
      toast.error(error.message || "Failed to create promo code");
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateCode = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "HZ-";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setPromoFormData({ ...promoFormData, code: result });
  };

  const handleAddTier = () => {
    setFormData({
      ...formData,
      tickets: [...formData.tickets, { name: "", quantity: 0, price: 10 }],
    });
  };

  const handleRemoveTier = (index) => {
    const newTickets = formData.tickets.filter((_, i) => i !== index);
    setFormData({ ...formData, tickets: newTickets });
  };

  const handleUpdateTier = (index, field, value) => {
    const newTickets = [...formData.tickets];
    newTickets[index][field] = value;
    setFormData({ ...formData, tickets: newTickets });
  };

  const handleEditClick = async (event) => {
    try {
      setLoading(true);
      const response = await eventService.getEventById(event._id || event.id);
      if (response && response.success) {
        const fullEvent = response.data;
        setFormData({
          title: fullEvent.title || "",
          category:
            categoryOptions.find((opt) => opt.value === fullEvent.category) ||
            null,
          visibility:
            visibilityOptions.find(
              (opt) => opt.value === fullEvent.visibility,
            ) || visibilityOptions[0],
          description: fullEvent.description || "",
          locationType:
            locationOptions.find(
              (opt) => opt.value === fullEvent.locationType,
            ) || locationOptions[0],
          venue: fullEvent.location || "",
          virtualPlatform:
            platformOptions.find(
              (opt) => opt.value === fullEvent.virtualPlatform,
            ) || null,
          meetingLink: fullEvent.meetingLink || "",
          startDate: fullEvent.startDate
            ? fullEvent.startDate.substring(0, 16)
            : "",
          endDate: fullEvent.endDate ? fullEvent.endDate.substring(0, 16) : "",
          salesEndDate: fullEvent.salesEndDate
            ? fullEvent.salesEndDate.substring(0, 16)
            : "",
          tickets: fullEvent.ticketTiers
            ? fullEvent.ticketTiers.map((t) => ({ ...t, quantity: t.capacity }))
            : [{ name: "Standard", quantity: 100, price: 0 }],
        });
        setPreviewImage(fullEvent.image || null);
        setCurrentEventId(fullEvent._id || fullEvent.id);
        setIsEditing(true);
        setActiveTab("create");
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
      toast.error("Failed to load event details");
    } finally {
      setLoading(false);
    }
  };

  const handleViewClick = async (event) => {
    try {
      setLoading(true);
      const response = await eventService.getEventById(event._id || event.id);
      if (response && response.success) {
        setSelectedEvent(response.data);
        setShowViewModal(true);
      }
    } catch (error) {
      console.error("Error viewing event:", error);
      toast.error("Failed to load event details");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setCurrentEventId(null);
    setFormData({
      title: "",
      category: null,
      visibility: visibilityOptions[0],
      description: "",
      locationType: locationOptions[0],
      venue: "",
      virtualPlatform: null,
      meetingLink: "",
      startDate: "",
      endDate: "",
      salesEndDate: "",
      tickets: [{ name: "Standard", quantity: 100, price: 0 }],
    });
    setPreviewImage(null);
    setImageFile(null);
    setActiveTab("listings");
  };

  const getEventsForDate = (date) => {
    return events.filter((event) => {
      const eventDate = new Date(event.startDate);
      return (
        eventDate.getDate() === date.getDate() &&
        eventDate.getMonth() === date.getMonth() &&
        eventDate.getFullYear() === date.getFullYear()
      );
    });
  };

  const eventMenu = [
    { id: "listings", label: "Event Listings", icon: "isax-list" },
    { id: "create", label: "Create Event", icon: "isax-add-circle" },
    { id: "promote", label: "Promote Event", icon: "isax-ranking" },
    { id: "promo", label: "Promo Codes", icon: "isax-ticket-discount" },
    { id: "attendees", label: "Attendees", icon: "isax-people" },
    { id: "tickets", label: "Tickets", icon: "isax-ticket" },
    { id: "schedule", label: "Schedule", icon: "isax-calendar" },
  ];

  return (
    <div>
      <Navbar {...props} />
      {/* Breadcrumb ... (rest of JSX) */}
      <div
        className="breadcrumb-bar"
        style={{
          backgroundColor: "var(--breadcrumb-bg)",
          transition: "background-color 0.3s ease",
        }}
      >
        <div className="container">
          <div className="row align-items-center inner-banner">
            <div className="col-md-12 col-12 text-center">
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">
                      <i className="isax isax-home-15" />
                    </a>
                  </li>
                  <li className="breadcrumb-item">Celebrity</li>
                  <li className="breadcrumb-item active">Events</li>
                </ol>
                <h2 className="breadcrumb-title">Events Management</h2>
              </nav>
            </div>
          </div>
        </div>
        <div className="breadcrumb-bg">
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-bg-01.png"
            alt="img"
            className="breadcrumb-bg-01"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-bg-02.png"
            alt="img"
            className="breadcrumb-bg-02"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-icon.png"
            alt="img"
            className="breadcrumb-bg-03"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-icon.png"
            alt="img"
            className="breadcrumb-bg-04"
          />
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-4 col-xl-3 theiaStickySidebar mb-4 mb-lg-0">
              <CelebSidebar user={user} />
            </div>
            <div className="col-12 col-lg-8 col-xl-9">
              <div className="event-nav-container mb-4">
                <div className="event-nav-scroller">
                  <div
                    className="nav nav-pills event-tabs"
                    id="event-pills-tab"
                    role="tablist"
                  >
                    {eventMenu.map((item) => (
                      <button
                        key={item.id}
                        className={`nav-link ${activeTab === item.id ? "active" : ""}`}
                        onClick={() => setActiveTab(item.id)}
                        type="button"
                      >
                        <div className="nav-link-content">
                          <div className="icon-wrapper">
                            <i className={`isax ${item.icon}`}></i>
                          </div>
                          <span>{item.label}</span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {activeTab === "listings" && (
                <EventListings
                  events={events}
                  loading={loading}
                  stats={stats}
                  setActiveTab={setActiveTab}
                  handleViewClick={handleViewClick}
                  handleEditClick={handleEditClick}
                />
              )}
              {activeTab === "promo" && (
                <PromoCodes
                  promoCodes={promoCodes}
                  loading={loading}
                  stats={promoStats}
                  setShowPromoModal={setShowPromoModal}
                />
              )}
              {activeTab === "attendees" && (
                <AttendeeList
                  attendees={attendees}
                  loading={loading}
                  stats={attendeeStats}
                />
              )}
              {activeTab === "tickets" && (
                <TicketInventory tickets={tickets} loading={loading} />
              )}
              {activeTab === "schedule" && (
                <EventSchedule
                  events={events}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  getEventsForDate={getEventsForDate}
                  handleViewClick={handleViewClick}
                  handleEditClick={handleEditClick}
                  setActiveTab={setActiveTab}
                />
              )}

              {activeTab === "create" && (
                <div className="create-event-form-container mt-2">
                  <div
                    className="card border-0 shadow-sm overflow-hidden"
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="card-header bg-white border-bottom-0 pt-4 px-4">
                      <h4 className="fw-bold mb-0">
                        {isEditing ? "Edit Event" : "Create New Event"}
                      </h4>
                      <p className="text-muted small">
                        {isEditing
                          ? "Update your event details"
                          : "Fill in the details below to launch your event"}
                      </p>
                    </div>
                    <div className="card-body px-4 pb-4">
                      <form onSubmit={handleCreateEvent}>
                        <div className="mb-4">
                          <label className="form-label fw-bold">
                            Event Banner / Flyer
                          </label>
                          <div className="event-upload-area overflow-hidden">
                            <input
                              type="file"
                              id="event-image"
                              className="d-none"
                              accept="image/*"
                              onChange={handleImageChange}
                            />
                            <label
                              htmlFor="event-image"
                              className="w-100 mb-0 pointer"
                            >
                              {previewImage ? (
                                <div
                                  className="preview-container position-relative"
                                  style={{ height: "250px" }}
                                >
                                  <img
                                    src={previewImage}
                                    alt="Preview"
                                    className="w-100 h-100 object-fit-cover"
                                  />
                                  <div className="preview-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 opacity-0 hover-opacity-100 transition-all">
                                    <span className="btn btn-sm btn-light rounded-pill">
                                      Change Image
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div className="upload-placeholder py-5 text-center">
                                  <i
                                    className="isax isax-image5 mb-2 text-primary"
                                    style={{ fontSize: "48px" }}
                                  ></i>
                                  <h5 className="mb-1">
                                    Click to upload banner
                                  </h5>
                                  <p className="text-muted small mb-0">
                                    Recommended size: 1200 x 630px (Max 1MB)
                                  </p>
                                </div>
                              )}
                            </label>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-8">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Event Title
                              </label>
                              <input
                                type="text"
                                className={`form-control custom-input ${errors.title ? "is-invalid" : ""}`}
                                placeholder="e.g. My Global Tech Summit"
                                value={formData.title}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    title: e.target.value,
                                  });
                                  if (errors.title) setErrors({ ...errors, title: null });
                                }}
                              />
                              {errors.title && <div className="invalid-feedback">{errors.title}</div>}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Category
                              </label>
                              <Select
                                styles={{
                                  ...selectStyles,
                                  control: (base, state) => ({
                                    ...selectStyles.control(base, state),
                                    borderColor: errors.category ? "#dc3545" : selectStyles.control(base, state).borderColor
                                  })
                                }}
                                options={categoryOptions}
                                placeholder="Select Category"
                                value={formData.category}
                                onChange={(opt) => {
                                  setFormData({ ...formData, category: opt });
                                  if (errors.category) setErrors({ ...errors, category: null });
                                }}
                              />
                              {errors.category && <div className="text-danger small mt-1">{errors.category}</div>}
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Description / About Event
                              </label>
                              <textarea
                                className={`form-control custom-input ${errors.description ? "is-invalid" : ""}`}
                                rows="4"
                                placeholder="Tell your audience what to expect..."
                                value={formData.description}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    description: e.target.value,
                                  });
                                  if (errors.description) setErrors({ ...errors, description: null });
                                }}
                              ></textarea>
                              {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Visibility
                              </label>
                              <div className="visibility-switch">
                                {visibilityOptions.map((opt) => (
                                  <div
                                    key={opt.value}
                                    className={`visibility-option ${formData.visibility?.value === opt.value ? "active" : ""}`}
                                    onClick={() =>
                                      setFormData({
                                        ...formData,
                                        visibility: opt,
                                      })
                                    }
                                  >
                                    <i
                                      className={`isax ${opt.value === "public" ? "isax-eye" : "isax-eye-slash"}`}
                                    ></i>
                                    <span>{opt.label.split(" ")[0]}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Location Type
                              </label>
                              <div className="visibility-switch">
                                {locationOptions.map((opt) => (
                                  <div
                                    key={opt.value}
                                    className={`visibility-option ${formData.locationType?.value === opt.value ? "active" : ""}`}
                                    onClick={() =>
                                      setFormData({
                                        ...formData,
                                        locationType: opt,
                                      })
                                    }
                                  >
                                    <i
                                      className={`isax ${opt.value === "Physical" ? "isax-location" : opt.value === "Virtual" ? "isax-monitor" : "isax-refresh-2"}`}
                                    ></i>
                                    <span>{opt.label}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          {(formData.locationType?.value === "Physical" ||
                            formData.locationType?.value === "Hybrid") && (
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  Venue / Physical Address
                                </label>
                                <input
                                  type="text"
                                  className="form-control custom-input"
                                  placeholder="Enter the physical venue address"
                                  value={formData.venue}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      venue: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          )}

                          {(formData.locationType?.value === "Virtual" ||
                            formData.locationType?.value === "Hybrid") && (
                            <>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label className="form-label fw-bold">
                                    Virtual Platform
                                  </label>
                                  <Select
                                    styles={selectStyles}
                                    options={platformOptions}
                                    placeholder="Select Platform"
                                    value={formData.virtualPlatform}
                                    onChange={(opt) =>
                                      setFormData({
                                        ...formData,
                                        virtualPlatform: opt,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <label className="form-label fw-bold">
                                    Meeting Link
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control custom-input"
                                    placeholder="Paste the meeting link (e.g. https://zoom.us/j/...)"
                                    value={formData.meetingLink}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        meetingLink: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </div>

                        <div className="mt-4 mb-4">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <label className="form-label fw-bold mb-0">
                                Ticket Tiers
                              </label>
                              <p className="text-muted small mb-0">
                                Define your ticket types and pricing
                              </p>
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary rounded-pill px-3"
                              onClick={handleAddTier}
                            >
                              <i className="isax isax-add-circle me-1"></i> Add
                              Tier
                            </button>
                          </div>

                          <div className="ticket-tiers-container">
                            {formData.tickets.map((tier, index) => (
                              <div
                                key={index}
                                className="ticket-tier-item p-3 mb-3 border rounded-4 bg-light-gray position-relative transition-all shadow-sm-hover"
                              >
                                <div className="row g-3 align-items-end">
                                  <div className="col-md-4">
                                    <label
                                      className="small fw-bold mb-1 text-muted text-uppercase"
                                      style={{
                                        fontSize: "0.65rem",
                                        letterSpacing: "0.05em",
                                      }}
                                    >
                                      Tier Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm custom-input"
                                      placeholder="e.g. VIP Early Bird"
                                      value={tier.name}
                                      onChange={(e) =>
                                        handleUpdateTier(
                                          index,
                                          "name",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label
                                      className="small fw-bold mb-1 text-muted text-uppercase"
                                      style={{
                                        fontSize: "0.65rem",
                                        letterSpacing: "0.05em",
                                      }}
                                    >
                                      Quantity
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm custom-input"
                                      placeholder="0"
                                      value={tier.quantity}
                                      onChange={(e) =>
                                        handleUpdateTier(
                                          index,
                                          "quantity",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="col-md-5">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <label
                                        className="small fw-bold text-muted text-uppercase mb-0"
                                        style={{
                                          fontSize: "0.65rem",
                                          letterSpacing: "0.05em",
                                        }}
                                      >
                                        Pricing
                                      </label>
                                      <div
                                        className="tier-type-toggle d-flex bg-white rounded-pill p-1 border"
                                        style={{ height: "32px" }}
                                      >
                                        <div
                                          className={`px-3 rounded-pill pointer d-flex align-items-center justify-content-center transition-all ${Number(tier.price) === 0 ? "bg-primary text-white shadow-sm" : "text-muted"}`}
                                          style={{
                                            fontSize: "0.75rem",
                                            fontWeight: "700",
                                          }}
                                          onClick={() =>
                                            handleUpdateTier(index, "price", 0)
                                          }
                                        >
                                          Free
                                        </div>
                                        <div
                                          className={`px-3 rounded-pill pointer d-flex align-items-center justify-content-center transition-all ${Number(tier.price) > 0 ? "bg-primary text-white shadow-sm" : "text-muted"}`}
                                          style={{
                                            fontSize: "0.75rem",
                                            fontWeight: "700",
                                          }}
                                          onClick={() => {
                                            if (Number(tier.price) === 0)
                                              handleUpdateTier(
                                                index,
                                                "price",
                                                10,
                                              );
                                          }}
                                        >
                                          Paid
                                        </div>
                                      </div>
                                    </div>
                                    <input
                                      type="number"
                                      className="form-control custom-input"
                                      placeholder="Price"
                                      disabled={Number(tier.price) === 0}
                                      value={tier.price}
                                      onChange={(e) =>
                                        handleUpdateTier(
                                          index,
                                          "price",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="col-md-1 d-flex align-items-center justify-content-center">
                                    {formData.tickets.length > 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-link text-danger p-0 mb-1"
                                        onClick={() => handleRemoveTier(index)}
                                      >
                                        <i
                                          className="isax isax-trash"
                                          style={{ fontSize: "1.2rem" }}
                                        ></i>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Revenue Projection Card */}
                          <div
                            className="revenue-projection-card p-3 rounded-4 border-dashed mt-3"
                            style={{
                              background: "rgba(255, 152, 0, 0.03)",
                              border: "2px dashed rgba(255, 152, 0, 0.2)",
                            }}
                          >
                            <div className="row align-items-center">
                              <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                  <div>
                                    <h6 className="fw-bold mb-0">
                                      Projected Revenue
                                    </h6>
                                    <p className="text-muted small mb-0">
                                      Total potential earnings from ticket sales
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 text-md-end mt-3 mt-md-0">
                                <div className="revenue-display">
                                  <span className="text-muted small fw-bold me-2">
                                    ESTIMATED TOTAL
                                  </span>
                                  <span
                                    className="display-6 fw-bold text-primary"
                                    style={{ fontSize: "1.8rem" }}
                                  >
                                    {formData.tickets
                                      .reduce(
                                        (acc, curr) =>
                                          acc +
                                          Number(curr.price || 0) *
                                            Number(curr.quantity || 0),
                                        0,
                                      )
                                      .toLocaleString()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-4">
                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Event Start
                              </label>
                              <input
                                type="datetime-local"
                                className={`form-control custom-input ${errors.startDate ? "is-invalid" : ""}`}
                                value={formData.startDate}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    startDate: e.target.value,
                                  });
                                  if (errors.startDate) setErrors({ ...errors, startDate: null });
                                }}
                              />
                              {errors.startDate && <div className="invalid-feedback">{errors.startDate}</div>}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Event End
                              </label>
                              <input
                                type="datetime-local"
                                className={`form-control custom-input ${errors.endDate ? "is-invalid" : ""}`}
                                value={formData.endDate}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    endDate: e.target.value,
                                  });
                                  if (errors.endDate) setErrors({ ...errors, endDate: null });
                                }}
                              />
                              {errors.endDate && <div className="invalid-feedback">{errors.endDate}</div>}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Sales End Date
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control custom-input"
                                value={formData.salesEndDate}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    salesEndDate: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <div className="text-end mt-4">
                          <button
                            type="button"
                            className="btn btn-light px-4 me-2 rounded-pill fw-bold"
                            onClick={handleCancelEdit}
                            disabled={loading}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary-gradient px-5 rounded-pill fw-bold d-inline-flex align-items-center justify-content-center"
                            disabled={loading}
                            style={{ minWidth: "180px" }}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                {isEditing ? "Updating..." : "Creating..."}
                              </>
                            ) : isEditing ? (
                              "Update Event"
                            ) : (
                              "Create Event"
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "promote" && (
                <div
                  className="card mt-4 border-0 shadow-sm"
                  style={{ borderRadius: "20px" }}
                >
                  <div className="card-body text-center py-5">
                    <i
                      className="isax isax-ranking mb-3 text-muted"
                      style={{ fontSize: "64px" }}
                    ></i>
                    <h4 className="fw-bold">Promote Your Event</h4>
                    <p className="text-muted px-5">Coming soon to Howzit!</p>
                    <button
                      className="btn btn-primary-gradient rounded-pill px-5 mt-2"
                      onClick={() => setActiveTab("listings")}
                    >
                      Back to Listings
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* View Event Modal */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        centered
        size="lg"
        className="premium-modal"
      >
        <Modal.Body className="p-0">
          {selectedEvent && (
            <div className="premium-view-container">
              {/* Banner with Glassmorphism Overlay */}
              <div className="premium-view-banner position-relative">
                <img
                  src={
                    selectedEvent.image ||
                    "https://via.placeholder.com/1200x600?text=Event+Banner"
                  }
                  alt="Banner"
                  className="w-100 object-fit-cover"
                  style={{ height: "300px" }}
                />
                <button
                  className="modal-close-btn"
                  onClick={() => setShowViewModal(false)}
                >
                  <i className="isax isax-close-circle"></i>
                </button>

                <div className="banner-content-overlay">
                  <div className="container-fluid px-4">
                    <span
                      className={`premium-status-badge ${selectedEvent.status?.toLowerCase() || "published"}`}
                    >
                      {selectedEvent.status || "Published"}
                    </span>
                    <h2 className="display-6 fw-bold text-white mt-2 mb-0 text-shadow">
                      {selectedEvent.title}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="p-4 p-lg-5">
                <div className="row g-4">
                  <div className="col-lg-7">
                    <div className="detail-section mb-4">
                      <h5 className="premium-section-title">Description</h5>
                      <p className="premium-text">
                        {selectedEvent.description ||
                          "Join us for this amazing experience. No detailed description provided yet."}
                      </p>
                    </div>

                    <div className="detail-section">
                      <h5 className="premium-section-title">Event Logistics</h5>
                      <div className="logistics-grid">
                        <div className="logistic-item">
                          <div className="logistic-icon bg-soft-primary">
                            <i className="isax isax-calendar-1 text-primary"></i>
                          </div>
                          <div>
                            <span className="logistic-label">Start Date</span>
                            <span className="logistic-value">
                              {new Date(
                                selectedEvent.startDate,
                              ).toLocaleDateString("default", {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              })}
                            </span>
                            <span className="logistic-value small text-muted">
                              at{" "}
                              {new Date(
                                selectedEvent.startDate,
                              ).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </span>
                          </div>
                        </div>

                        <div className="logistic-item">
                          <div className="logistic-icon bg-soft-danger">
                            <i className="isax isax-location text-danger"></i>
                          </div>
                          <div>
                            <span className="logistic-label">Location</span>
                            <span className="logistic-value">
                              {selectedEvent.location || "TBA"}
                            </span>
                            <span className="logistic-value small text-muted">
                              {selectedEvent.locationType} Event
                            </span>
                          </div>
                        </div>

                        <div className="logistic-item">
                          <div className="logistic-icon bg-soft-info">
                            <i className="isax isax-category text-info"></i>
                          </div>
                          <div>
                            <span className="logistic-label">Category</span>
                            <span className="logistic-value">
                              {selectedEvent.category}
                            </span>
                          </div>
                        </div>

                        <div className="logistic-item">
                          <div className="logistic-icon bg-soft-success">
                            <i className="isax isax-eye text-success"></i>
                          </div>
                          <div>
                            <span className="logistic-label">Visibility</span>
                            <span className="logistic-value text-capitalize">
                              {selectedEvent.visibility}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-5">
                    <div className="ticket-inventory-card p-4">
                      <h5 className="premium-section-title mb-4">
                        Ticket Inventory
                      </h5>
                      <div className="premium-tier-list">
                        {selectedEvent.ticketTiers?.map((tier, idx) => (
                          <div key={idx} className="premium-tier-card">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="tier-name">{tier.name}</span>
                              <span className="tier-price">${tier.price}</span>
                            </div>
                            <div
                              className="progress mb-2"
                              style={{ height: "6px", borderRadius: "10px" }}
                            >
                              <div
                                className="progress-bar bg-primary"
                                role="progressbar"
                                style={{
                                  width: `${Math.min(100, ((tier.soldCount || 0) / (tier.capacity || 1)) * 100)}%`,
                                }}
                              ></div>
                            </div>
                            <div className="d-flex justify-content-between small text-muted">
                              <span>{tier.soldCount || 0} Sold</span>
                              <span>{tier.capacity} Total</span>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="mt-4 pt-3 border-top">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-600 text-dark">
                            Total Capacity
                          </span>
                          <span className="badge bg-soft-primary text-primary px-3 rounded-pill">
                            {selectedEvent.totalCapacity ||
                              selectedEvent.ticketTiers?.reduce(
                                (acc, t) => acc + t.capacity,
                                0,
                              )}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-600 text-dark">Total Sales</span>
                          <span className="fw-bold text-success">
                            $
                            {selectedEvent.ticketTiers?.reduce(
                              (acc, t) => acc + t.price * (t.soldCount || 0),
                              0,
                            )}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="d-grid gap-2 mt-4">
                      <button
                        className="btn btn-primary-gradient py-3 rounded-3 fw-bold shadow-sm"
                        onClick={() => {
                          setShowViewModal(false);
                          handleEditClick(selectedEvent);
                        }}
                      >
                        <i className="isax isax-edit-2 me-2"></i> Edit Event
                        Details
                      </button>
                      <button
                        className="btn btn-outline-secondary py-2 border-0 text-muted"
                        onClick={() => setShowViewModal(false)}
                      >
                        Back to Management
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showPromoModal}
        onHide={() => setShowPromoModal(false)}
        centered
        size="lg"
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">Create Promo Code</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <form onSubmit={handleCreatePromo}>
            <div className="row">
              <div className="col-md-12 mb-4">
                <label className="form-label fw-bold">Promo Code *</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control custom-input"
                    style={{ background: "#fff" }}
                    placeholder="e.g. SAVE20"
                    value={promoFormData.code}
                    onChange={(e) =>
                      setPromoFormData({
                        ...promoFormData,
                        code: e.target.value.toUpperCase(),
                      })
                    }
                  />
                  <button
                    className="btn btn-outline-primary px-3 fw-bold"
                    type="button"
                    style={{ borderRadius: "0 10px 10px 0" }}
                    onClick={handleGenerateCode}
                  >
                    Auto-Generate
                  </button>
                </div>
              </div>

              <div className="col-md-12 mb-4">
                <label className="form-label fw-bold">Select Event *</label>
                <Select
                  styles={selectStyles}
                  options={events.map((e) => ({
                    value: e._id || e.id,
                    label: e.title,
                  }))}
                  placeholder="Which event is this for?"
                  value={promoFormData.event}
                  onChange={(opt) =>
                    setPromoFormData({ ...promoFormData, event: opt })
                  }
                />
              </div>

              <div className="col-md-7 mb-4">
                <label className="form-label fw-bold">Discount Type</label>
                <div className="visibility-switch">
                  {discountTypeOptions.map((opt) => (
                    <div
                      key={opt.value}
                      className={`visibility-option ${promoFormData.type?.value === opt.value ? "active" : ""}`}
                      onClick={() =>
                        setPromoFormData({ ...promoFormData, type: opt })
                      }
                    >
                      <i
                        className={`isax ${opt.value === "percentage" ? "isax-percentage" : "isax-money-send"}`}
                      ></i>
                      <span>{opt.label.split(" ")[0]}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-5 mb-4">
                <label className="form-label fw-bold">
                  Value (
                  {promoFormData.type?.value === "percentage" ? "%" : "Amt"})
                </label>
                <input
                  type="number"
                  className="form-control custom-input"
                  style={{ background: "#fff" }}
                  placeholder="0"
                  value={promoFormData.value}
                  onChange={(e) =>
                    setPromoFormData({
                      ...promoFormData,
                      value: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Min. Tickets</label>
                <input
                  type="number"
                  className="form-control custom-input"
                  style={{ background: "#fff" }}
                  placeholder="1"
                  value={promoFormData.minTickets}
                  onChange={(e) =>
                    setPromoFormData({
                      ...promoFormData,
                      minTickets: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Max Uses</label>
                <input
                  type="number"
                  className="form-control custom-input"
                  style={{ background: "#fff" }}
                  placeholder="Unlimited"
                  value={promoFormData.maxUses}
                  onChange={(e) =>
                    setPromoFormData({
                      ...promoFormData,
                      maxUses: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Expiry Date</label>
                <input
                  type="date"
                  className="form-control custom-input"
                  style={{ background: "#fff" }}
                  value={promoFormData.expiryDate}
                  onChange={(e) =>
                    setPromoFormData({
                      ...promoFormData,
                      expiryDate: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="text-end mt-4">
              <button
                type="button"
                className="btn btn-light px-4 me-2 rounded-pill fw-bold"
                onClick={() => setShowPromoModal(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary-gradient px-5 rounded-pill fw-bold d-inline-flex align-items-center justify-content-center"
                disabled={loading}
                style={{ minWidth: "180px" }}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Creating...
                  </>
                ) : (
                  "Create Promo"
                )}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <style jsx="true">{`
        .event-nav-container { background: #fff; border-radius: 15px; padding: 10px; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05); }
        .event-nav-scroller { overflow-x: auto; scrollbar-width: none; -ms-overflow-style: none; }
        .event-nav-scroller::-webkit-scrollbar { display: none; }
        .event-tabs { display: flex; flex-wrap: nowrap; gap: 10px; border: none; }
        .event-tabs .nav-link { border: none; background: transparent; padding: 12px 20px; border-radius: 12px; color: #6c757d; min-width: 120px; transition: all 0.3s ease; }
        .event-tabs .nav-link:hover { background: rgba(255, 152, 0, 0.05); color: #ff9800; }
        .event-tabs .nav-link.active { background: linear-gradient(45deg, #ff9800, #ff5722); color: #fff; box-shadow: 0 4px 12px rgba(255, 87, 34, 0.3); }
        
        .premium-dashboard-card { background: #ffffff; border-radius: 20px; border: 1px solid #f1f5f9; box-shadow: 0 1px 3px rgba(0,0,0,0.05); overflow: hidden; }
        .premium-card-header { padding: 1.25rem 1.5rem; border-bottom: 1px solid #f1f5f9; background: rgba(248, 250, 252, 0.7); display: flex; align-items: center; justify-content: space-between; }
        
        .premium-calendar-grid { 
          display: grid; 
          grid-template-columns: repeat(7, minmax(80px, 1fr)); 
          gap: 10px; 
          padding: 1.25rem; 
          overflow-x: auto;
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .premium-calendar-grid::-webkit-scrollbar { display: none; }
        .premium-weekday { 
          text-align: center; 
          font-weight: 700; 
          color: #94a3b8; 
          font-size: 0.75rem; 
          text-transform: uppercase; 
          padding: 10px 0;
        }
        .premium-calendar-day { 
          padding: 0.75rem; 
          border: 1px solid #f1f5f9; 
          border-radius: 1rem; 
          cursor: pointer; 
          min-height: 80px; 
          background: #ffffff; 
          position: relative; 
          transition: all 0.2s ease; 
          display: flex;
          flex-direction: column;
        }
        .premium-calendar-day:hover { border-color: #ff9800; transform: translateY(-2px); }
        .premium-calendar-day.is-selected { background: rgba(255, 152, 0, 0.05); border-color: #ff9800; box-shadow: 0 0 0 2px rgba(255, 152, 0, 0.2); }
        .premium-calendar-day.has-events { background-color: rgba(16, 185, 129, 0.03); }
        
        .apt-preview { padding: 6px 8px; border-radius: 8px; border-left: 3px solid #e2e8f0; font-size: 0.7rem; font-weight: 600; background: #f8fafc; margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; transition: all 0.2s; }
        .apt-preview:hover { opacity: 0.8; transform: translateX(2px); }
        .apt-preview.status-published { border-left-color: #10b981; background: #ecfdf5; color: #065f46; }
        .apt-preview.status-draft { border-left-color: #64748b; background: #f1f5f9; color: #334155; }
        .apt-preview.status-pending { border-left-color: #f59e0b; background: #fffbeb; color: #92400e; }

        .premium-event-card { padding: 1.25rem; border-radius: 1rem; border: 1px solid #f1f5f9; background: #ffffff; margin-bottom: 1rem; border-left: 4px solid #ff9800; transition: all 0.3s ease; }
        .premium-event-card:hover { transform: translateY(-2px); box-shadow: 0 10px 15px rgba(0,0,0,0.05); }
        .premium-event-card.status-published { border-left-color: #10b981; }
        .premium-event-card.status-draft { border-left-color: #64748b; }
        .premium-event-card.status-pending { border-left-color: #f59e0b; }
        
        .status-badge-premium { padding: 4px 10px; border-radius: 999px; font-size: 0.65rem; font-weight: 700; text-transform: uppercase; }
        .status-published-bg { background: #dcfce7; color: #166534; }
        .status-draft-bg { background: #f1f5f9; color: #475569; }
        .status-pending-bg { background: #fef3c7; color: #92400e; }

        .view-toggle-group { display: inline-flex; padding: 4px; background: #f1f5f9; border-radius: 12px; border: 1px solid #e2e8f0; }
        .view-toggle-btn { padding: 6px 16px; font-size: 0.8rem; font-weight: 700; border-radius: 8px; border: none; transition: all 0.2s; color: #64748b; background: transparent; }
        .view-toggle-btn.active { background: #ffffff; color: #0f172a; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }

        .sort-btn { background: transparent; border: 1px solid #e2e8f0; padding: 4px 12px; border-radius: 8px; font-size: 0.75rem; color: #64748b; transition: all 0.2s; }
        .sort-btn:hover { background: #f8fafc; color: #ff9800; border-color: #ff9800; }
        .sort-btn.active { background: rgba(255, 152, 0, 0.1); color: #ff9800; border-color: #ff9800; font-weight: 700; }

        .event-action-group { display: flex; gap: 8px; margin-top: 15px; padding-top: 15px; border-top: 1px solid #f1f5f9; }
        .action-btn-pill { padding: 8px 16px; font-size: 0.75rem; font-weight: 700; border-radius: 10px; border: none; transition: all 0.2s; display: inline-flex; align-items: center; gap: 6px; }
        .btn-view { background: #f1f5f9; color: #475569; }
        .btn-view:hover { background: #e2e8f0; }
        .btn-edit { background: rgba(255, 152, 0, 0.1); color: #ff9800; }
        .btn-edit:hover { background: rgba(255, 152, 0, 0.2); }

        .custom-input { border-radius: 10px; padding: 10px 14px; border: 1px solid #eee; background: #fafafa; font-size: 0.9rem; }
        .custom-input:focus { border-color: #ff9800; box-shadow: 0 0 0 0.25rem rgba(255, 152, 0, 0.1); background: #fff; }
        .ticket-tier-item .custom-input { background: #ffffff !important; }
        .bg-light-gray { background-color: #f8f9fa; }
        .pointer { cursor: pointer; }

        /* PREMIUM VIEW MODAL STYLES */
        .premium-modal .modal-content { border-radius: 24px; border: none; overflow: hidden; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); }
        .premium-view-banner { height: 300px; overflow: hidden; }
        .banner-content-overlay { position: absolute; bottom: 0; left: 0; right: 0; padding: 40px 0 20px; background: linear-gradient(to top, rgba(0,0,0,0.85), transparent); }
        .modal-close-btn { position: absolute; top: 20px; right: 20px; z-index: 10; background: rgba(255, 255, 255, 0.2); backdrop-filter: blur(8px); border: 1px solid rgba(255, 255, 255, 0.3); color: white; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; transition: all 0.3s ease; }
        .modal-close-btn:hover { background: rgba(255, 255, 255, 0.4); transform: rotate(90deg); }
        
        .premium-status-badge { padding: 6px 16px; border-radius: 9999px; font-size: 0.75rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; }
        .premium-status-badge.published { background: #10b981; color: white; }
        
        .premium-section-title { font-size: 1.1rem; font-weight: 800; color: #0f172a; margin-bottom: 1.25rem; position: relative; padding-left: 15px; }
        .premium-section-title::before { content: ""; position: absolute; left: 0; top: 4px; bottom: 4px; width: 4px; background: #ff9800; border-radius: 4px; }
        .premium-text { color: #475569; line-height: 1.7; font-size: 0.95rem; }
        
        .logistics-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px; }
        .logistic-item { display: flex; gap: 15px; align-items: flex-start; }
        .logistic-icon { width: 44px; height: 44px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
        .bg-soft-primary { background: #eff6ff; }
        .bg-soft-danger { background: #fef2f2; }
        .bg-soft-info { background: #ecfeff; }
        .bg-soft-success { background: #f0fdf4; }
        
        .logistic-label { display: block; font-size: 0.7rem; font-weight: 700; color: #94a3b8; text-transform: uppercase; margin-bottom: 2px; }
        .logistic-value { display: block; font-size: 0.9rem; font-weight: 600; color: #1e293b; }
        
        .ticket-inventory-card { background: #f8fafc; border-radius: 20px; border: 1px solid #f1f5f9; }
        .premium-tier-card { background: white; padding: 15px; border-radius: 12px; margin-bottom: 12px; border: 1px solid #f1f5f9; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
        .tier-price { font-weight: 800; color: #ff9800; }
        .text-shadow { text-shadow: 0 2px 4px rgba(0,0,0,0.3); }

        /* UPLOAD AREA PREMIUM STYLES */
        .event-upload-area { 
          background: #f8fafc; 
          border: 2px dashed #cbd5e1; 
          border-radius: 20px; 
          transition: all 0.3s ease; 
          position: relative;
        }
        .event-upload-area:hover { 
          border-color: #ff9800; 
          background: #f1f5f9;
        }
        .upload-placeholder { cursor: pointer; padding: 40px 20px; }
        .upload-placeholder i { transition: transform 0.3s ease; }
        .event-upload-area:hover .upload-placeholder i { transform: translateY(-5px); color: #ff9800 !important; }

        /* VISIBILITY SWITCH STYLES */
        .visibility-switch {
          display: flex;
          background: #f1f5f9;
          padding: 5px;
          border-radius: 14px;
          border: 1px solid #e2e8f0;
          gap: 4px;
        }
        .visibility-option {
          flex: 1;
          padding: 8px 12px;
          text-align: center;
          font-size: 0.8rem;
          font-weight: 700;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          color: #64748b;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          border: 1px solid transparent;
        }
        .visibility-option i { font-size: 1.1rem; }
        .visibility-option.active {
          background: #ffffff;
          color: #ff9800;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          border-color: #f1f5f9;
        }
        .visibility-option:not(.active):hover {
          background: rgba(255, 152, 0, 0.05);
          color: #ff9800;
        }

        /* DARK MODE SUPPORT (REFINED) */
        [data-theme='dark'] .event-upload-area { background: #111111; border-color: #334155; }
        [data-theme='dark'] .event-upload-area:hover { border-color: #ff9800; background: #1a1a1a; }
        [data-theme='dark'] .visibility-switch { background: #111111; border-color: #262626; }
        [data-theme='dark'] .visibility-option.active { background: #262626; color: #ff9800; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3); border-color: #333; }
        [data-theme='dark'] .visibility-option:not(.active):hover { background: #1a1a1a; }

        [data-theme='dark'] .event-nav-container,
        [data-theme='dark'] .premium-dashboard-card,
        [data-theme='dark'] .premium-calendar-day,
        [data-theme='dark'] .premium-event-card,
        [data-theme='dark'] .modern-card,
        [data-theme='dark'] .ticket-inventory-card,
        [data-theme='dark'] .premium-tier-card,
        [data-theme='dark'] .create-event-form-container .card,
        [data-theme='dark'] .event-stat-card {
          background-color: #0a0a0a !important;
          border-color: #262626 !important;
          color: #fafafa !important;
        }

        [data-theme='dark'] .premium-card-header,
        [data-theme='dark'] .modern-filter-bar,
        [data-theme='dark'] .modern-table-header,
        [data-theme='dark'] .card-header {
          background-color: #0a0a0a !important;
          border-color: #262626 !important;
        }

        [data-theme='dark'] .text-dark,
        [data-theme='dark'] .premium-section-title,
        [data-theme='dark'] .logistic-value,
        [data-theme='dark'] .tier-name,
        [data-theme='dark'] .fw-bold,
        [data-theme='dark'] .form-label,
        [data-theme='dark'] .modern-table-header h2 {
          color: #fafafa !important;
        }

        [data-theme='dark'] .modern-table th,
        [data-theme='dark'] .custom-table thead th {
          background-color: #111111 !important;
          color: #a3a3a3 !important;
          border-bottom-color: #262626 !important;
        }

        [data-theme='dark'] .modern-table td,
        [data-theme='dark'] .custom-table td,
        [data-theme='dark'] .event-row {
          background-color: #0a0a0a !important;
          border-bottom-color: #262626 !important;
          color: #fafafa !important;
        }

        [data-theme='dark'] .modern-table tr:hover,
        [data-theme='dark'] .event-row:hover,
        [data-theme='dark'] .custom-table tbody tr:hover {
          background-color: #1a1a1a !important;
        }

        [data-theme='dark'] .text-muted,
        [data-theme='dark'] .premium-text,
        [data-theme='dark'] .logistic-label,
        [data-theme='dark'] .form-control,
        [data-theme='dark'] .custom-input {
          background-color: #0a0a0a !important;
          border-color: #262626 !important;
          color: #fafafa !important;
        }

        [data-theme='dark'] .logistic-icon { background-color: #1a1a1a !important; }
        [data-theme='dark'] .ticket-inventory-card { background-color: #111111 !important; border-color: #262626 !important; }
        [data-theme='dark'] .modal-content { background-color: #0a0a0a !important; border: 1px solid #262626; }
      `}</style>
      <Footer {...props} />
    </div>
  );
};

export default CelebEvents;
